/**
 * PQR Data Utilities
 * 
 * Utility functions for processing and formatting PQR data
 */

import React from "react";

export const formatPQRDate = (dateString) => {
  if (!dateString) return "";
  
  const currentDate = new Date(dateString);
  const day = currentDate.getDate();
  const month = currentDate.getMonth() + 1;
  const year = currentDate.getFullYear();
  
  return isNaN(day) ? "" : `${day}-${month}-${year}`;
};

export const getPQRValue = (value, defaultValue = "--") => 
  value === "" || value === undefined ? defaultValue : value;

export const bindWeldProcess = (pdf, type, index) => {
  const arrayMap = [];

  if (pdf[index] && pdf[index][type]) {
    pdf[index][type].forEach((element) => {
      if(element && element!= "")
      arrayMap.push(element);
    });
  }

  const count = arrayMap.length;
  
  const renderTds = () => {
    if (count === 1) {
      return <td  style={{width: "400px", textAlign: "center"}}>{arrayMap[0]}</td>;
    }
    
    if (count === 2) {
      return (
        <>
          <td  style={{width: "200px", textAlign: "center" }}>{arrayMap[0]}</td>
          <td  style={{width: "200px", textAlign: "center"}}>{arrayMap[1]}</td>
        </>
      );
    }
    
    if (count === 3) {
      return (
        <>
          <td  style={{width: "200px", textAlign: "center"}}>{arrayMap[0]}</td>
          <td  style={{width: "200px", textAlign: "center"}}>{arrayMap[1]}</td>
          <td  style={{width: "200px", textAlign: "center"}}>{arrayMap[2]}</td>
        </>
      );
    }
    
    return null;
  };

  return <tr key={1}>{renderTds()}</tr>;
};

export const getColumnClasses = (pdf, pageType = "default") => {
  
  const validItems = pdf.filter(item => item !== undefined && item !== null && item !== "");
  //4 proces sis in new page
  const count = validItems.length >=5 ? 3 : validItems.length - 1;
  console.log("pdf", pdf,count);
  
  const pageWidthMaps = {
    position: {
      1: "90%",
      2: "38.6%", 
      3: "25%"
    },
    preheat: {
      1: "90%",
      2: "38.8%", 
      3: "25%"
    },
   electric: {
      1: "90%",
      2: "38.3%", 
      3: "25%"
    },
    gas: {
      1: "90%",
      2: "40.6%", 
      3: "25%"
    },
    default: {
      1: "90%",
      2: "40%", 
      3: "25%"
    }
  };
  
  const widthMap = pageWidthMaps[pageType] || pageWidthMaps.default;
  const colwidth = widthMap[count] || "90%";
  console.log("width map",widthMap,widthMap[count])
  
  return {
    colwidth,
    col1Class: "PQRleft7-td-noleft",
    col2Class: count >= 2 ? "PQRleft7-td-noright" : "PQRtdhidden",
    col3Class: count >= 3 ? "PQRleft7-td-noright" : "PQRtdhidden",
   // col4Class: count === 4 ? "PQRleft7-td-noright" : "PQRtdhidden"
  };
};

